import States from './States.jsx';

export default function StatesWithDisabled(disabledStates) {
  const states = States();

  return states.map(item => {
    if (disabledStates.includes(item.value)) {
      item.label = `${item.label} (Not Available)`;
      item.disabled = true;
    }
    return item;
  });
}
